import React from 'react';


import './gallery.css';
import im1 from  '../src/images/services.jpg'
import im2 from  '../src/images/services1.jpg'
import im3 from  '../src/images/services2.jpeg'




const cardData = [
  {
    title: 'Construction',
    description: 'This is a description for service one.',
    img: im1,
    link: 'projects'
    
  },
  {
    title: 'Architect',
    description: 'This is a description for service two.',
    img: im2
  },
  {
    title: 'Interior',
    description: 'This is a description for service three.',
    img: im3,
    link: 'interior'
  },
 
];

const Services = () => {
  

  return (
    <>
    <h2 className="text-center" style={{letterSpacing:'2px',lineHeight:'40px',color:'hsl(255, 93%, 30%)'}}>Our Expertise</h2>
    <h6 className="text-center" style={{color:'rgb(134, 198, 39)',fontSize:'13px',letterSpacing:'1px',fontStyle:'oblique'}}>Our expertise takes your vision from concept to creation — with craftsmanship you can trust.</h6>
    <div className="d-md-flex mx-4 mt-4 mb-2">

    {cardData.map((card, index) => (
  <div className="card" key={index}>
    <div className="image-wrapper">
<img src={card.img} alt={'We offer interior design services including modern interiors, home décor, modular kitchen design, custom wardrobes, false ceiling and lighting, affordable interior solutions, living room ideas, bedroom expertise, and full home interior packages'} className="card-image" />
      <div className={`image-hover-effect ${(index + 1) % 2 === 0 ? 'active-by-default' : ''}`}></div>
      {index === 0 || index === 2 ? (
        <a href={`/#${card.link}`} style={{ textDecoration: 'none' }}>
          <h6 className="p-3 text-light" style={{ backgroundColor: 'rgb(134, 198, 39)' }}>
            {card.title}
          </h6>
        </a>
      ) : (
        <h6 className="p-3 text-light" style={{ backgroundColor: 'rgb(134, 198, 39)' }}>
          {card.title}
        </h6>
      )}

    </div>
    
  </div>
))}

    </div>

 

    </>
  );
};

export default Services;
